import { render } from "./PaywallLinksBlock.vue?vue&type=template&id=6e1afd34&scoped=true"
import script from "./PaywallLinksBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallLinksBlock.vue?vue&type=script&setup=true&lang=js"

import "./PaywallLinksBlock.vue?vue&type=style&index=0&id=6e1afd34&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1afd34"],['__file',"src/components/PaywallLinksBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e1afd34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e1afd34', __exports__)) {
    console.log('reload')
    api.reload('6e1afd34', __exports__)
  }
  
  module.hot.accept("./PaywallLinksBlock.vue?vue&type=template&id=6e1afd34&scoped=true", () => {
    console.log('re-render')
    api.rerender('6e1afd34', render)
  })

}


export default __exports__